import { Box, CircularProgress } from '@mui/material';

export type LoadingIndicatorProps = {
  /** Defaults to full-page loading. Use e.g. `48` for inline/table usage. */
  height?: number | string;
  /** Spinner size (px). */
  size?: number;
};

const LoadingIndicator = ({ height = '100vh', size }: LoadingIndicatorProps) => (
  <Box display="flex" justifyContent="center" alignItems="center" height={height} width="100%">
    <CircularProgress size={size} />
  </Box>
);

export default LoadingIndicator;
